<template>
  <div class="with-form">
    <h3 class="title is-4">{{ title }}</h3>
    <p class="description">{{ description }}</p>
    <form @submit.prevent="handleNext && handleNext()">
      <slot />
      <div class="columns buttons">
        <div v-if="handlePrevious" class="column">
          <button class="button is-primary is-fullwidth" type="button" @click="handlePrevious">Previous</button>
        </div>
        <div v-if="handleNext" class="column">
          <button class="button is-primary is-fullwidth" type="submit" :disabled="isDisabled">Next</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Form',
  props: {
    title: String,
    description: String,
    handlePrevious: Function,
    handleNext: Function,
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
